import { jsx, Fragment } from "react/jsx-runtime";
import { createContext, useCallback } from "react";
import { useEnvironment } from "./useEnvironment.js";
import { Environment } from "../dao/Environment.js";
import { Component } from "../coreComponents/Component.js";
const EnvironmentContext = createContext(Environment.create());
EnvironmentContext.displayName = "EnvironmentContext";
const EnvironmentMiddleware = Component(
  ({ children, create }) => {
    const env = useEnvironment();
    return /* @__PURE__ */ jsx(EnvironmentContext.Provider, { value: create(env), children });
  },
  {
    staticRender: ({ children }) => {
      return /* @__PURE__ */ jsx(Fragment, { children });
    },
    generateEnvironment: ({ create }, env) => {
      return create(env);
    }
  }
);
const EnvironmentExtensionProvider = Component(
  ({ children, extension, state }) => {
    const create = useCallback((env) => env.withExtension(extension, state), [extension, state]);
    return /* @__PURE__ */ jsx(EnvironmentMiddleware, { create, children });
  },
  ({ children, extension, state }) => {
    const create = (env) => env.withExtension(extension, state);
    return /* @__PURE__ */ jsx(EnvironmentMiddleware, { create, children });
  }
);
export {
  EnvironmentContext,
  EnvironmentExtensionProvider,
  EnvironmentMiddleware
};
//# sourceMappingURL=EnvironmentContext.js.map
